import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { useAuth } from '../auth/AuthProvider.jsx';
import { kioskApi } from '../api/kiosk.js';
import { ConfirmDialog } from '../components/ui/ConfirmDialog.jsx';
import { env } from '../lib/env.js';

const STORAGE_KEY = 'orme:kiosk:session';

export function KioskLayout() {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onLogout = async () => {
    setSubmitting(true);
    try {
      // Revoke the visitor's anonymous consent (if any) before
      // detaching the device, so a residual customerSessionId in
      // localStorage cannot survive the next operator's login.
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
          const parsed = JSON.parse(raw);
          if (parsed && parsed.customerSessionId) {
            await kioskApi.revoke(parsed.customerSessionId, 'kiosk_logout').catch(() => {});
          }
        }
        localStorage.removeItem(STORAGE_KEY);
      } catch (_e) { /* ignore storage errors */ }
      await logout();
      navigate('/login', { replace: true });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex h-screen flex-col bg-surface">
      <header className="border-b border-border bg-surface-elevated px-8 py-4">
        <div className="mx-auto flex max-w-5xl items-center justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-ink-muted">{env.appName}</p>
            <p className="text-base font-medium text-ink">Assistente in negozio</p>
          </div>
          {isAuthenticated && user && (
            <div className="flex items-center gap-3">
              <p className="text-xs text-ink-muted">Postazione: <code className="text-ink">{user.email}</code></p>
              <button
                type="button"
                onClick={() => setConfirmOpen(true)}
                className="rounded-md border border-border px-3 py-1.5 text-xs text-ink-muted hover:bg-border/40 hover:text-ink"
              >
                Chiudi Postazione
              </button>
            </div>
          )}
        </div>
      </header>
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>

      <ConfirmDialog
        open={confirmOpen}
        title="Disconnettere la postazione?"
        description="La sessione del cliente in corso (se presente) sarà revocata. Per riavviare l'assistente serviranno di nuovo le credenziali dell'account kiosk."
        destructive
        confirmLabel="Esci"
        loading={submitting}
        onCancel={() => setConfirmOpen(false)}
        onConfirm={onLogout}
      />
    </div>
  );
}
